import * as React from "react";
import "./labeled-value.css";
import { Popup } from "semantic-ui-react";

export default function LabeledValue({ label, value, desc = undefined }: {
    label: string;
    value: string | number | null | undefined;
    desc?: string;
}): JSX.Element {
    return (
        <div className="labeledValue">
            <div className="label">
                {desc === undefined && label}
                {desc !== undefined && <Popup content={desc} trigger={<span className="labelWithPopup">{label}</span>}/>}
            </div>
            <div className="value">{value}</div>
        </div>
    );
}
